// analytics constants

import type { IssueTypeSchemeFilter, Page, Project } from './IssueTypeScheme.types.tsx';

export const ORDER: Readonly<{
	ASC: 'asc';
	DESC: 'desc';
}> = Object.freeze({
	ASC: 'asc',
	DESC: 'desc',
});

const MAX_RESULTS = 10;

export const defaultIssueTypeSchemesFilter: IssueTypeSchemeFilter = {
	pageNumber: 1,
	pageSize: MAX_RESULTS,
	expand: ['projects', 'issueTypes'],
	orderBy: 'name',
	sortDirection: 'DESC',
};

export const EMPTY_PROJECTS_PAGE: Page<Project> = {
	startAt: 0,
	maxResults: 10,
	values: [],
	total: 0,
	isLast: true,
};

export const FILTER_CHANGE_ANALYTICS: Readonly<{
	ACTION: 'changed';
	ACTION_SUBJECT: 'filterSearch';
}> = Object.freeze({
	ACTION: 'changed',
	ACTION_SUBJECT: 'filterSearch',
});
